export default {
  summary: {
    delivery: 'Bezorging: Cadeaukaart als PDF per e-mail',
  },
};
